import sliders from "./imports/sliders";
import header from "./imports/header";
import apiRest from "./imports/apiRest";

window.addEventListener('DOMContentLoaded', () => {
    header();
    sliders();
    apiRest();
})